<template>
    <div style="max-width: 48em;">
        <h3 class="block w-full" style="font-family:arial,sans-serif;font-style: normal;font-size: 18px;line-height: 1.33;color: #1a0dab;font-weight:400;">Clevedon Ford | {{ title }}</h3>
        <span class="block w-full" style="font-family:arial,sans-serif;font-size: 14px;padding-top: 1px;line-height: 1.43;color: #006621;font-style: normal;">{{ url }}/{{ slug }}</span>
        <p style="font-family:arial,sans-serif;font-size:small;line-height: 1.54;color: #545454;">{{ description }}</p>
    </div>
</template>

<script>
    import {
        APP_URL
    } from '@/constants/default';

    export default {
        props: {
            title: {
                type: String,
                required: false,
                default: ''
            },
            description: {
                type: String,
                required: false,
                default: ''
            },
            slug: {
                type: String,
                required: false,
                default: ''
            }
        },

        data: () => ({
            url: APP_URL
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/SEO.vue